import { render, staticRenderFns } from "./ProductSearchBarComponent.vue?vue&type=template&id=71a0b263"
import script from "./ProductSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./ProductSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductSearchBarComponent.vue?vue&type=style&index=0&id=71a0b263&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports